import React, { createContext, useState, useContext, useEffect } from "react";
import { getAllCompanies } from "../api/settingsCompanyApi";

const CompaniesContext = createContext();

export const CompaniesProvider = ({ children }) => {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCompany, setSelectedCompany] = useState(null);

  useEffect(() => {
    getAllCompanies()
      .then((data) => {
        setCompanies(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Failed to fetch companies:", err);
        setLoading(false);
      });
  }, []);

  return (
    <CompaniesContext.Provider
      value={{
        companies,
        loading,
        selectedCompany,
        setSelectedCompany,
      }}
    >
      {children}
    </CompaniesContext.Provider>
  );
};

export const useCompanies = () => useContext(CompaniesContext);
